var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var CardPayment_1;
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener, number, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { Card, Image, Text } from '@philips-internal/oswald-ui-components/lib/components';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import React, { Component } from 'react';
import CardPaymentApi from './card-payment-api';
import { SituationType } from './card-payment-type';
import './card-payment.css';
import { LanguageService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { NumberFormatUtils } from '../../util/number-format-utils';
import CanceledSVG from '../../assets/images/icons/Canceled.svg';
import ConfirmedSVG from '../../assets/images/icons/Confirmed.svg';
import CalendarSVG from '../../assets/images/icons/calendar.svg';
import TitleTranferredSVG from '../../assets/images/icons/Alternate-arrows.svg';
import WarningSVG from '../../assets/images/icons/warning.svg';
import moment from 'moment';
import { ModelService } from '@philips-internal/oswald-ui-core/lib/services';
const statusPropMap = new Map([
    [SituationType.OPEN, { icon: CalendarSVG, label: 'patient.opened' }],
    [SituationType.PAID, { icon: ConfirmedSVG, label: 'patient.filtered-paid-status-checkbox' }],
    [SituationType.CANCELED, { icon: CanceledSVG, label: 'patient.canceled' }],
    [SituationType.TITLE_TRANSFERRED, { icon: TitleTranferredSVG, label: 'patient.transferred' }],
    [SituationType.LATE, { icon: WarningSVG, label: 'patient.late' }]
]);
let CardPayment = class CardPayment extends Component {
    static { CardPayment_1 = this; }
    static { this.propTypes = { className: string, onClick: eventListener, uuid: string, width: number }; }
    static { this.defaultProps = { width: 12 }; }
    onClick() {
        const { onClick, accountNumber, accountPayableBalanceValue, accountPayableNumber, accountSettlementDate, currentAmountFine, establishmentDescription, expirationDate, issueDate, status, totalValue, } = this.props;
        if (isFunction(onClick)) {
            onClick(new ClickEvent({
                value: {
                    accountNumber,
                    accountPayableBalanceValue,
                    accountPayableNumber,
                    accountSettlementDate,
                    currentAmountFine,
                    establishmentDescription,
                    expirationDate,
                    issueDate,
                    status,
                    totalValue,
                }
            }));
        }
    }
    render() {
        const { uuid, className, width = CardPayment_1.defaultProps.width, expirationDate, totalValue, status, accountSettlementDate, accountNumber, isLatePayment, latePaymentDays } = this.props;
        let situationType = status;
        let textSituationType = MessageService.translate(statusPropMap.get(status)?.label || '');
        const lateDays = latePaymentDays || '';
        if (isLatePayment) {
            situationType = SituationType.LATE;
            textSituationType = MessageService.translate('patient.day-late');
        }
        const iconStatus = statusPropMap.get(situationType)?.icon || '';
        const savedAtFormatted = ModelService.format('date', expirationDate, { type: 'shortDate' });
        const currencySymbol = MessageService.translate('patient.currency-symbol');
        const totalFormatted = NumberFormatUtils.formatToCurrentLanguage(totalValue, currencySymbol, true);
        const localeStr = LanguageService.getCurrentLanguage().replace('_', '-');
        const dateFormat = moment(accountSettlementDate).locale(localeStr).format('DD MMMM YY');
        return (React.createElement(Card, { uuid: uuid, selectionType: SelectionType.SINGLE, width: width, className: className, onClick: () => this.onClick() },
            React.createElement("div", { className: 'payment' },
                React.createElement("div", { className: "detail-area" },
                    React.createElement("div", { className: "info-content" },
                        React.createElement("span", { className: "emphasis-info account-date" },
                            React.createElement(Text, { bold: true, value: dateFormat })),
                        React.createElement("span", { className: "account-number" },
                            React.createElement(Text, { value: `${MessageService.translate('patient.number-abbreviation') + ' ' + accountNumber}` })))),
                React.createElement("div", { className: 'payment-info' },
                    React.createElement("div", { className: "detail-area due-date" },
                        React.createElement("div", { className: "info-content" },
                            React.createElement("span", { className: "label-info" },
                                React.createElement(Text, { value: `${MessageService.translate('patient.due-date')}` })),
                            React.createElement("span", { className: "emphasis-info" },
                                React.createElement(Text, { bold: true, value: savedAtFormatted })))),
                    React.createElement("div", { className: "detail-area" },
                        React.createElement("div", { className: "info-content" },
                            React.createElement("span", { className: "label-info" },
                                React.createElement(Text, { value: `${MessageService.translate('tws.label-total')}` })),
                            React.createElement("span", { className: "emphasis-info" },
                                React.createElement(Text, { bold: true, value: totalFormatted })))),
                    React.createElement("div", { className: "detail-area" },
                        React.createElement("div", { className: "info-content-status" },
                            React.createElement("div", { className: 'content-text-status' },
                                React.createElement(Text, { value: lateDays + ' ' + `${textSituationType}` })),
                            React.createElement("div", { className: 'status-icon' },
                                React.createElement(Image, { src: iconStatus, alt: '' }))))))));
    }
    renderSituationType() {
        const { status } = this.props;
        return (React.createElement("div", { className: 'deck-title-payments-list' },
            React.createElement("span", null, MessageService.translate(statusPropMap.get(status)?.label || ''))));
    }
};
CardPayment = CardPayment_1 = __decorate([
    AwesomeComponent({ api: CardPaymentApi, type: ComponentType.DATA_DISPLAY })
], CardPayment);
export default CardPayment;
//# sourceMappingURL=card-payment.js.map